const MenuType = {
  MAIN: "MAIN",
  ADMIN: "ADMIN",
  ALL: "ALL",
};

export default MenuType;
